export const Navmenu = [
  { title: "Home", link: "home" },
  { title: "About", link: "about" },
  { title: "Mitra", link: "mitra" },
  { title: "Product", link: "product" },
  { title: "Sign Up", link: "signup" },
];
